import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve } from "@angular/router";
import { Observable, from } from "rxjs";

import { DbService } from "./db.service";
import { BaseMap } from "../interfaces/base-map";

@Injectable({
    providedIn: 'root'
})
export class MapsResolver implements Resolve<BaseMap[]> {

    constructor(private db: DbService) { }

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseMap[]> {
        return from(this.db.getUserMaps());
    }
}
